import { capitalize } from 'lodash-es';

import { bold, Summary } from './primitives';
import type { SummarySlice } from './types';

export const librarySummaries = {
  'library.created': ({ entry, ctx }) => {
    if (entry.isChild && entry.parentName) {
      return (
        <Summary>
          Child {ctx.libraryKind} of&nbsp;{bold(entry.parentName)}&nbsp;created
        </Summary>
      );
    }
    return <div>{capitalize(ctx.libraryKind)} created</div>;
  },

  'library.deleted': ({ ctx }) => <div>{capitalize(ctx.libraryKind)} deleted</div>,

  'library.restored': ({ ctx }) => <div>{capitalize(ctx.libraryKind)} restored</div>,

  'library.deactivated': ({ ctx }) => <div>{capitalize(ctx.libraryKind)} deactivated</div>,

  'library.reactivated': ({ ctx }) => <div>{capitalize(ctx.libraryKind)} reactivated</div>,

  'library.effective_from_changed': ({ entry }) => (
    <Summary>Effective from date changed to&nbsp;{bold(entry.to)}</Summary>
  ),

  'library.effective_to_changed': ({ entry }) => <Summary>Effective to date changed to&nbsp;{bold(entry.to)}</Summary>,

  'library.team_filter_changed': ({ entry, ctx }) => {
    const resolvedTeams = entry.to === 'None' ? 'None' : entry.to.split(', ').map(ctx.teamName).join(', ');
    return (
      <Summary>
        Team filter changed to&nbsp;{bold(resolvedTeams)}&nbsp;for {ctx.libraryKind}
      </Summary>
    );
  },

  'library.cob_filter_changed': ({ entry, ctx }) => (
    <Summary>
      Class-of-business filter changed to&nbsp;{bold(entry.to)}&nbsp;for {ctx.libraryKind}
    </Summary>
  ),

  'library.classification_changed': ({ entry, ctx }) => (
    <Summary>
      Classification changed to&nbsp;{bold(entry.to)}&nbsp;for {ctx.libraryKind}
    </Summary>
  ),

  'library.permission_changed': ({ entry, ctx }) => (
    <Summary>
      {bold(entry.permission)}&nbsp;set to&nbsp;{bold(entry.to)}&nbsp;for {ctx.libraryKind}
    </Summary>
  ),

  'library.clause_type_changed': ({ entry, ctx }) => (
    <Summary>
      Clause type changed to&nbsp;{bold(entry.to)}&nbsp;for {ctx.libraryKind}
    </Summary>
  ),

  'library.content_edited': ({ ctx }) => <div>{capitalize(ctx.libraryKind)} content edited</div>,

  'library.content_imported': ({ ctx }) => <Summary>Imported file content into&nbsp;{bold(ctx.targetName)}</Summary>,

  'library.name_changed': ({ entry, ctx }) => (
    <Summary>
      {capitalize(ctx.libraryKind)} renamed to&nbsp;{bold(entry.to)}
    </Summary>
  ),

  'library.variant_added': ({ entry, ctx }) => (
    <Summary>
      {bold(entry.name)}&nbsp;variant added for {ctx.libraryKind}
    </Summary>
  ),

  'library.variant_edited': ({ entry, ctx }) => (
    <Summary>
      {bold(entry.name)}&nbsp;variant edited for {ctx.libraryKind}
    </Summary>
  ),

  'library.variant_renamed': ({ entry, ctx }) => (
    <Summary>
      {bold(entry.from)}&nbsp;variant renamed to&nbsp;{bold(entry.to)}&nbsp;for {ctx.libraryKind}
    </Summary>
  ),

  'library.variant_removed': ({ entry, ctx }) => (
    <Summary>
      {bold(entry.name)}&nbsp;variant removed for {ctx.libraryKind}
    </Summary>
  ),
} satisfies SummarySlice;
